import { render } from "./ViewChallengeLeaderboard.vue?vue&type=template&id=f150af68&scoped=true"
import script from "./ViewChallengeLeaderboard.vue?vue&type=script&lang=js"
export * from "./ViewChallengeLeaderboard.vue?vue&type=script&lang=js"

import "@/css/views/view-challenge-leaderboard.css?vue&type=style&index=0&id=f150af68&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f150af68"]])

export default __exports__